export default __webpack_public_path__ + "static/media/KiTEC.009b4422.webp";